@if (getContentData().title !== '' && promoType()) {
<div class="promo__container">
    <div class="promo__wrap">
        <content-landing [title]="getContentData().title" [imageUrl]="getContentData().image"
            [description]="getContentData().description"
            (promoInteraction)="trackPromoInteraction($event.action, $event.label)" />

        @if (promoType() === 'worldCup') {
        <world-cup-banner [data]="getContentData()"
            (promoInteraction)="trackPromoInteraction($event.action, $event.label)" />
        }

        @if(isPromoExpired() && promoType() !== 'affiliate' && promoType()) {
        <promo-expired />
        }@else if(!isPromoExpired() && promoType() !== 'migrateHalo' || promoType() !== 'affiliate' || promoType() !== 'bundling4G') {
        <period-landing [label]="getContentData().period_text" [dateTime]="getContentData() | dateTime:promoType()" />
        }

        @if (promoType() === 'bundling4G') {
            <app-countdown [endDate]="getContentData().end_date"/>
        }

        <check-offers [data]="getContentData()" [categoryType]="categoryContent" />

        @if (promoType() === 'worldCup') {
            <world-cup-schedule/>
        }

        @if (promoType() !== 'claimVoucher') {
        <tnc-landing [termsTitle]="getContentData().terms_title" [termsContent]="getContentData().terms"
            [buttonTextHide]="getContentData().hide_text" [buttonTextShow]="getContentData().load_text"
            (promoInteraction)="trackPromoInteraction($event.action, $event.label)" />
        }

        <tag-list [tagTitle]="getContentData().tags_title" [tagList]="getContentData().tags"
            (promoInteraction)="trackPromoInteraction($event.action, $event.label)" />
    </div>
</div>
}
